import { FC } from "react";
import { Outlet } from "react-router-dom";

const AclPage: FC = (): JSX.Element => {
 return <Outlet />;
};
export default AclPage;
